<template>
  <div class="signatures-two-column">
    <div class="signature-wrapper signature-left">
      <document-part-signature :signatures="signatures" :payload="signatureHolders[0]" :state="state" :viewer="viewer" @update="update"></document-part-signature>
    </div>
    <div class="signature-wrapper signature-right">
      <document-part-signature :signatures="signatures" :payload="signatureHolders[1]" :state="state" :viewer="viewer"  @update="update"></document-part-signature>
    </div>
  </div>
</template>

<script>
  import Utils from 'utils';
  import DocumentPartSignature from './signature.vue';

  // This content block is solely responsible for generating GUID's for each signature location
  export default {
    props: [
      'part', 'signatures', 'state', 'viewer'
    ],
    components: {
      DocumentPartSignature
    },
    data() {
      return {
        signatureHolders: [
          { uuid: Utils.uuid(), signatory: false, metadata: [{ label: 'Title', value: '' }] },
          { uuid: Utils.uuid(), signatory: false, metadata: [{ label: 'Title', value: '' }] }
        ]
      }
    },
    beforeMount() {
      if (this.part && this.part.content && _.isArray(this.part.content)) {
        this.signatureHolders = this.part.content;
      } else {
        this.update();
      }
    },
    methods: {
      update(payload) {
        if (payload) {
          this.signatureHolders.forEach((holder, index, holders) => {
              if (holder.uuid === payload.uuid) {
                  holders[index] = payload;
              }
          });
        }
        this.part.content = this.signatureHolders;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .signatures-two-column {
    width: 100%;
  }
  .signature-wrapper {
    position: relative;
    float: left;
    width: 50%;
    padding: 30px;
    &.signature-left {
      padding-left: 0;
    }
    &.signature-right {
      padding-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// signatures.vue?f87dd21a